import { soFetch } from 'so-fetch';
import * as constants from './product-constants';
import checkStatus from '../../../utils/checkStatus';
import * as queries from './product-graphql-query';

export function getNonLoggedInUsersProductProfile(productId) {
  return soFetch(`/proxy/products/${productId}?query=${queries.productProfileQuery}`, {
    method: 'get',
    actionType: constants.GET_PRODUCT_PROFILE,
  });
}



// WEBPACK FOOTER //
// ./src/app/stores/company/product/product-actions.js